import { graphql, useStaticQuery } from 'gatsby';
import { useEffect, useState } from 'react';
import isPreview from '../../utils/isPreview';
import { useLoading } from '../../context/QueryLoadingContext';

function formatTeamMembers(teamMembers) {
  const formattedTeamsMembers = teamMembers.map((teamMember) => ({
    name: teamMember.name,
    function: teamMember.function,
    jobDescription: teamMember.job_description,
    isLead: !!teamMember.lead,
    description: teamMember.description,
    profilePicture: `${process.env.DIRECTUS_URI}assets/${teamMember.profile_picture.id}`,
    profilePictureBackground: teamMember.profile_picture_background
      ? `${process.env.DIRECTUS_URI}assets/${teamMember.profile_picture_background.id}`
      : null,
    active: teamMember.active,
  }));

  const director = formattedTeamsMembers.shift();

  return {
    director,
    members: formattedTeamsMembers,
  };
}

function getStaticTeamMembers() {
  const { team_members: teamMembers } = useStaticQuery(graphql`
    query {
      directus {
        team_members {
          name
          function
          job_description
          lead
          description
          profile_picture{
            id
          }
          profile_picture_background {
            id
          }
          active
        }
      }
    }
  `).directus;

  return formatTeamMembers(teamMembers);
}

async function getTeamMembers() {
  const f = await fetch(`${process.env.DIRECTUS_URI}graphql/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `{
        team_members {
          name
          function
          job_description
          lead
          description
          profile_picture{
            id
          }
          profile_picture_background {
            id
          }
          active
        }
      }`,
    }),
  });
  const res = await f.json();

  return formatTeamMembers(res.data.team_members);
}

export default function useGetTeamMembers() {
  const [teamMembers, setTeamMembers] = useState(getStaticTeamMembers());
  const { setLoading } = useLoading();

  useEffect(() => {
    if (isPreview()) {
      setLoading(true);

      getTeamMembers().then((data) => {
        setTeamMembers(data);
        setLoading(false);
      });
    }
  }, []);

  return teamMembers;
}
